import React from 'react';
import { PREVIEW, PRODUCTION, generateSurfaceUrl } from '../../../common/utils/environments';
import { getBuilderURL } from '../../../common/utils/builder-url-util';
import { getCookie } from '../../../common/utils/api_utils';

export const Summary = ({ projectId, version, projectDetail, installedPlugins, items = [] }) => {
  const { seoName } = projectDetail || '';
  const multiTenantInstalled = installedPlugins.find((plg) => plg.code === 'MULTI_TENANT_SAAS');

  const taskDone = [
    'Login Plugin: Installed successfully.',
    'Role Collection: Created.',
    'User Collection: Created.',
    'Role Data: Created.',
    'Role Based Layout: Created.',
  ];
  const systemDefaultUsernames = ['superadmin@test.com', 'tenantadmin@test.com'];
  if (multiTenantInstalled) {
    taskDone.splice(1, 0, 'Multi Tenant Plugin: Installed successfully.');
    taskDone.splice(3, 0, 'Tenant Collection: Created.');
    taskDone.splice(5, 1, 'Role Data: Created.');
    taskDone.splice(6, 1, 'Role Based Layout: Created.');
    taskDone.push('Tenant Data: Created. (Tenant 1 and Tenant 2)');
  }

  const previewUrl = generateSurfaceUrl(PREVIEW, seoName);
  const productionUrl = generateSurfaceUrl(PRODUCTION, seoName);
  const redirectUrl = getBuilderURL();
  let token = getCookie('token');
  if (!token) token = '';

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <h3>Here's what we've accomplished so far:</h3>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-8">
          {taskDone.map((task, index) => (
            <h5 key={index}>
              <i className="wb webconnect-check icon-green" style={{ color: 'green' }}></i> {task}
            </h5>
          ))}
          <h5>
            <i className="wb webconnect-check icon-green" style={{ color: 'green' }}></i> User Data:
            Created.
          </h5>
          <table className="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>Username</th>
                <th>Role</th>
                <th>Password</th>
              </tr>
            </thead>
            <tbody>
              {items.map((user, index) => {
                const isSystemDefault = systemDefaultUsernames.includes(user.userName);
                if (!multiTenantInstalled && user.userName === 'demouser3@test.com') {
                  return null;
                }
                return (
                  <tr key={index}>
                    <td>
                      {user.userName}
                      {isSystemDefault && (
                        <span style={{ fontSize: '12px', color: 'green' }}> (System Default)</span>
                      )}
                    </td>
                    <td>
                      {Array.isArray(user.userRoles) ? user.userRoles.join(', ') : user.userRoles}
                    </td>
                    <td>12345678</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <h5>
            <i className="wb webconnect-check icon-green" style={{ color: 'green' }}></i> Close
            Modal Event: Created.
          </h5>
          <div className="mt-4">
            <h3>Your web app links:</h3>
            <h5>
              <b>Preview:</b>
              <a
                className="icon-link"
                style={{ color: '#1F2041' }}
                href={previewUrl}
                target="_blank"
                title="Open link in new tab"
              >
                <i className="wb webconnect-box-arrow-in-up-right" title="Open link in new tab"></i>
                &nbsp;{previewUrl}
              </a>
            </h5>
            <h5>
              <b>Production:</b>
              <a
                className="icon-link"
                style={{ color: '#1F2041' }}
                href={productionUrl}
                target="_blank"
                title="Open link in new tab"
              >
                <i className="wb webconnect-box-arrow-in-up-right" title="Open link in new tab"></i>
                &nbsp;{productionUrl}
              </a>
            </h5>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="alert alert-success rounded mt-4">
            🎉 Congratulations! You have successfully completed all the basic steps. Now, you can
            dive straight into building your web app. Hit the button below to start creating. Best
            of luck!
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-md-8 text-right mt-2">
          <a
            className="btn btn-primary btn-md mb-3"
            href={`${redirectUrl}editor/${version}/v/${projectId}/loader?token=${token}`}
            title="Start Building your App"
          >
            <i className="wb webconnect-rocket"></i> Continue Building
          </a>
        </div>
      </div>
    </div>
  );
};
